import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { AboutSection } from '../components/home/AboutSection';
import { ServicesPreview } from '../components/home/ServicesPreview';
// import { VisitorCounter } from '../components/home/VisitorCounter';
import { BusinessHours } from '../components/home/BusinessHours';
import { CTASection } from '../components/home/CTASection';

export const HomePage = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ServicesPreview />
      {/* <VisitorCounter /> */}
      <AboutSection />
      <BusinessHours />
      <CTASection />
    </div>
  );
};
